import axiosInstance from "../axios";
import { Sentry } from "../sentry";
import { getStoreBrandName, isStore } from "../utils";

/**
 * Allowed `profile_type` values for store (Zerobuild-scoped) signup.
 * Backend requirement (as shared):
 * contractor, home_owner, interior_designer, kitchen_company, architect,
 * carpenter, vendor, oems, builder
 */
const ALLOWED_PROJECT_TYPES = [
  "contractor",
  "home_owner",
  "interior_designer",
  "kitchen_company",
  "architect",
  "carpenter",
  "vendor",
  "oems",
  "builder",
];

const normalizeProjectType = (projectType) => {
  if (projectType === undefined || projectType === null) return null;
  const v = String(projectType).trim();
  if (!v) return null;
  return v.toLowerCase();
};

export const login = ({ mobileNumber, password, code }) => {
  return axiosInstance.post("/auth/login", {
    mobile: mobileNumber,
    password: password,
    code: code,
  });
};

export const loginOtp = ({ mobileNumber, otp }) => {
  return axiosInstance.post("/auth/login", {
    mobile: mobileNumber,
    otp_code: otp,
  });
};

export const fetchOtp = ({ mobileNumber, from = "login" }) => {
  return axiosInstance.post(`/auth/generate_otp`, {
    mobile: mobileNumber,
    from,
  });
};

export const register = ({
  fullName,
  companyName,
  mobileNumber,
  password,
  profile,
  size,
  buildMode,
  otp,
  store,
  projectType,
}) => {
  const isZeroBuildStore =
    isStore() && String(getStoreBrandName() || "").toLowerCase() === "zerobuild";

  const normalizedProjectType = normalizeProjectType(projectType);
  if (
    normalizedProjectType &&
    !ALLOWED_PROJECT_TYPES.includes(normalizedProjectType)
  ) {
    throw new Error(
      `profile_type must be one of: ${ALLOWED_PROJECT_TYPES.join(", ")}`
    );
  }

  /**
   * Store/Zerobuild signup uses existing endpoint: POST /api/users/register
   *
   * Backend expects for store signups:
   * - required: mobile, otp_code, company, store=1
   * - optional: profile_type (from ALLOWED_PROJECT_TYPES)
   *
   * Important: app must NOT set user.verified anywhere; OTP here just completes registration.
   */
  const requestData =
    store
      ? {
          // Keep sending name if available (backend may store it).
          ...(fullName ? { name: fullName } : {}),
          mobile: mobileNumber,
          otp_code: otp,
          // Zerobuild requirement: all Zerobuild users under org name "ZeroBuild".
          company: isZeroBuildStore ? "ZeroBuild" : companyName,
          store: 1,
          ...(normalizedProjectType
            ? { profile_type: normalizedProjectType }
            : {}),
        }
      : {
          name: fullName,
          company: companyName,
          mobile: mobileNumber,
          password: password,
          profile: profile,
          size: size,
          build_mode: buildMode,
          otp_code: otp,
          store: store,
        };

  console.log("API request data:", requestData);
  return axiosInstance.post("/users/register", requestData);
};

export const getCurrentUser = () => {
  const currentUser = localStorage.getItem("currentUser");

  return JSON.parse(currentUser);
};

export const setUserAsGuest = () => {
  localStorage.clear("accessToken");
  localStorage.clear("currentUser");
};

export const setAuthenticatedUser = ({ token, user }) => {
  localStorage.setItem("accessToken", token);
  localStorage.setItem("currentUser", JSON.stringify(user));

  Sentry.setUser({
    mobile: user.mobile,
    name: user.name,
    organization: user.org_name,
  });
};
